import { FormControl, ListGroupItem } from 'react-bootstrap';
import React from 'react';
import HOC from '../../../components/GeneralInputField/';
import ClockPicker from '../../../components/ClockPicker/';
const BootstrapInput = HOC(props => {
  const onKeyPress = e => {
    if (e.key === 'Enter') {
      props.input.onBlur(e);
    }
  };
  return (
    <div>
      <FormControl
        {...props.componentProps}
        value={props.input.value}
        onChange={props.input.onChange}
        onBlur={props.input.onBlur}
        onFocus={props.input.onFocus}
        autoFocus={props.ifAutoFocus}
        onKeyPress={onKeyPress}
        disabled={props.disabled}
      />
    </div>
  );
});

const ClockPickerInput = HOC(props => {
  return (
    <div>
      <ClockPicker
        {...props.componentProps}
        value={props.input.value}
        onChange={props.input.onChange}
        onBlur={props.input.onBlur}
        onFocus={props.input.onFocus}
        meta={props.meta}
        disabled={props.disabled}
      />
      {props.meta.asyncValidating ? (
        <FormControl.Feedback style={{ width: 'inherit', height: 'inherit', right: '60px', top: '10px' }}>
          <i className="fa fa-spinner fa-spin" />
        </FormControl.Feedback>
      ) : null}
    </div>
  );
});

const TextInput = HOC(props => {
  const onKeyPress = e => {
    if (e.key === 'Enter') {
      props.input.onBlur(e);
    }
  };
  return (
    <FormControl
      componentClass="textarea"
      {...props.componentProps}
      value={props.input.value}
      onChange={props.input.onChange}
      onBlur={props.input.onBlur}
      onFocus={props.input.onFocus}
      autoFocus={props.ifAutoFocus}
      onKeyPress={onKeyPress}
      disabled={props.disabled}
    />
  );
});


const selectControl = HOC(props => {
  const result = props.componentProps.selectData.map((val, index) => (
    <option value={val.value} key={index}>
      {val.label}
    </option>
  ));
  const onKeyPress = e => {
    if (e.key === 'Enter') {
      props.input.onBlur(e);
    }
  };
  return (
    <FormControl
      onKeyPress={onKeyPress}
      autoFocus={props.ifAutoFocus}
      {...props.input}
      componentClass="select"
      disabled={props.disabled}
    >
      <option value="">Choose Option</option>
      {result}
    </FormControl>
  );
});


export const SubHeaderOutbound = props => {
  return (
    <ListGroupItem className='main-list-item' >
      {props.to}<div className="fromTo" >&gt;</div>{props.from}
    </ListGroupItem>
  );
};

export const transferDetailsOutboundState = val => {
  const result1 = {
    transferTypeEdit: false,
    dateEdit: false,
    timeEdit: false,
    flightNumberEdit: false,
    adultsEdit: false,
    childrenEdit: false,
    skiSnowboards: false,
    bikesSurfboards: false,
    holdLuggage: false,
    pickupTime: false,
    firstNameEdit: false,
    lastNameEdit: false,
    emailEdit: false,
    phoneEdit: false,
    busNumber: false,
    departureStop: false,
    arrivalStop: false,
    accommodationNameEdit: false,
    accommodationAddressEdit: false,
    toAccommodationNameEdit: false,
    toAccommodationAddressEdit: false,
    notesEdit: false
  };
  for (let i = 0; i < val; i++) {
    result1[`childAge${i}Edit`] = false;
    result1[`seatType${i}Edit`] = false;
  }
  return result1;
};

export const transferDetailsOutboundSelectors = val => {
  const result2 = {
    to: 'toValue',
    from: 'fromValue',
    transferType: 'transferTypeValue',
    date: 'dateValue',
    time: 'timeValue',
    flightNumber: 'flightNumberValue',
    adults: 'adultsValue',
    children: 'childrenValue',
    skiSnowboards: 'skiSnowboardsValue',
    bikesSurfboards: 'bikesSurfboardsValue',
    holdLuggage: 'holdLuggageValue',
    pickupTime: 'pickupTimeValue',
    firstName: 'firstNameValue',
    lastName: 'lastNameValue',
    email: 'emailValue',
    phone: 'phoneValue',
    busNumber: 'busNumberValue',
    departureStop: 'departureStopValue',
    arrivalStop: 'arrivalStopValue',
    accommodationName: 'accommodationNameValue',
    accommodationAddress: 'accommodationAddressValue',
    toAccommodationName: 'toAccommodationNameValue',
    toAccommodationAddress: 'toAccommodationAddressValue',
    notes: 'notesValue',
    id: 'idValue'
  };
  for (let i = 0; i < val; i++) {
    result2[`childAge${i}`] = `childAge${i}Value`;
    result2[`seatType${i}`] = `seatType${i}Value`;
  }
  return result2;
};

export const transferDetailsOutboundFields = (val, transfers, options, info) => [
  {
    componentProps: {
      label: 'Transfer Type',
      type: 'text',
      selectData: options.transferOptions
        ? options.transferOptions.map(val => {
            return { value: val.transferTypeCode, label: val.transferType };
          })
        : []
    },
    errorMessage: 'Required',
    component: selectControl,
    data: 'transferTypeValue',
    name: 'transferType'
  },
  {
    componentProps: {
      label: 'Outbound Date',
      type: 'date'
    },
    errorMessage: 'You must provide a date',
    component: TextInput,
    data: 'dateValue',
    name: 'date'
  },
  {
    componentProps: {
      label: transfers.timeLabel,
      type: 'time'
    },
    errorMessage: 'You must provide a time',
    component: ClockPickerInput,
    data: 'timeValue',
    name: 'time'
  },
  {
    componentProps: {
      label: transfers.flightNumberLabel,
      type: 'text'
    },
    errorMessage: 'Required',
    component: BootstrapInput,
    data: 'flightNumberValue',
    name: 'flightNumber',
    required: !transfers.showFlightNumber
  },
  {
    componentProps: {
      label: 'Adults',
      type: 'number',
      min: '1'
    },
    errorMessage: 'You must provide a value',
    component: BootstrapInput,
    data: 'adultsValue',
    name: 'adults'
  },
  {
    componentProps: {
      label: 'Children',
      type: 'number',
      min: '0',
      max: '15'
    },
    errorMessage: 'You must provide a value',
    component: BootstrapInput,
    data: 'childrenValue',
    name: 'children'
  },
  ...transfers.children.map((val, index) => {
    return {
      componentProps: {
        label: `Child ${index + 1} age`,
        type: 'select',
        selectData: info.childAges.reduce((result, val) => {
          result.push({ value: val.age, label: val.description });
          return result;
        }, [])
      },
      errorMessage: 'Required',
      component: selectControl,
      data: `childAge${index}Value`,
      name: `childAge${index}`
    };
  }, {}),
  ...transfers.children.map((val, index) => {
    return {
      componentProps: {
        label: `Seat Type ${index + 1}`,
        type: 'select',
        selectData: info.seatTypes.reduce((result, val) => {
          result.push({ value: val.seat_type_code, label: val.seat_type });
          return result;
        }, [])
      },
      errorMessage: 'Required',
      component: selectControl,
      data: `seatType${index}Value`,
      name: `seatType${index}`
    };
  }, {}),
  {
    componentProps: {
      label: 'Ski / snowboards',
      type: 'number',
      min: '0'
    },
    errorMessage: 'You must provide a value',
    component: BootstrapInput,
    data: 'skiSnowboardsValue',
    name: 'skiSnowboards'
  },
  {
    componentProps: {
      label: 'Bikes / Golf Bags',
      type: 'number',
      min: '0'
    },
    errorMessage: 'You must provide a value',
    component: BootstrapInput,
    data: 'bikesSurfboardsValue',
    name: 'bikesSurfboards'
  },
  {
    componentProps: {
      label: 'Items of Hold Luggage',
      type: 'number',
      min: '0'
    },
    errorMessage: 'You must provide a value',
    component: BootstrapInput,
    data: 'holdLuggageValue',
    name: 'holdLuggage'
  },
  {
    name: 'TransferHeader'
  },
  {
    componentProps: {
      label: 'First Name',
      type: 'text'
    },
    errorMessage: 'Required',
    component: BootstrapInput,
    data: 'firstNameValue',
    name: 'firstName'
  },
  {
    componentProps: {
      label: 'Last Name',
      type: 'text'
    },
    errorMessage: 'Required',
    component: BootstrapInput,
    data: 'lastNameValue',
    name: 'lastName'
  },
  {
    componentProps: {
      label: 'Email',
      type: 'email'
    },
    errorMessage: 'Required',
    component: BootstrapInput,
    data: 'emailValue',
    name: 'email'
  },
  {
    componentProps: {
      label: 'Phone Number',
      type: 'tel'
    },
    errorMessage: 'You must provide a value',
    component: BootstrapInput,
    data: 'phoneValue',
    name: 'phone'
  },
  {
    componentProps: {
      label: 'Bus Number',
      type: 'text',
      selectData: transfers.shuttle.showTimes
        ? transfers.shuttle.options.times.map(val => {
            return { value: val.id, label: val.options };
          })
        : []
    },
    errorMessage: 'Required',
    component: selectControl,
    data: 'busNumberValue',
    name: 'busNumber',
    required: !transfers.shuttle.showTimes
  },
  {
    componentProps: {
      label: 'Bus Station',
      type: 'text',
      selectData: transfers.shuttle.showFrom
        ? transfers.shuttle.options.stopsFrom.map(val => {
            return { value: val.id, label: val.options };
          })
        : []
    },
    errorMessage: 'Required',
    component: selectControl,
    data: 'departureStopValue',
    name: 'departureStop',
    required: !transfers.shuttle.showFrom
  },
  {
    componentProps: {
      label: 'Bus Station',
      type: 'text',
      selectData: transfers.shuttle.showTo
        ? transfers.shuttle.options.stopsTo.map(val => {
            return { value: val.id, label: val.options };
          })
        : []
    },
    errorMessage: 'Required',
    component: selectControl,
    data: 'arrivalStopValue',
    name: 'arrivalStop',
    required: !transfers.shuttle.showTo
  },
  {
    componentProps: {
      label: 'From Accommodation Name',
      type: 'text'
    },
    errorMessage: 'You must provide a value',
    component: BootstrapInput,
    data: 'accommodationNameValue',
    name: 'accommodationName',
    required: !transfers.fromAccommodation.show
  },
  {
    componentProps: {
      label: 'From Accommodation Address',
      type: 'text'
    },
    errorMessage: 'You must provide a value',
    component: BootstrapInput,
    data: 'accommodationAddressValue',
    name: 'accommodationAddress',
    required: !transfers.fromAccommodation.show
  },
  {
    componentProps: {
      label: 'To Accommodation Name',
      type: 'text'
    },
    errorMessage: 'You must provide a value',
    component: BootstrapInput,
    data: 'toAccommodationNameValue',
    name: 'toAccommodationName',
    required: !transfers.toAccommodation.show
  },
  {
    componentProps: {
      label: 'To Accommodation Address',
      type: 'text'
    },
    errorMessage: 'You must provide a value',
    component: BootstrapInput,
    data: 'toAccommodationAddressValue',
    name: 'toAccommodationAddress',
    required: !transfers.toAccommodation.show
  },
  {
    componentProps: {
      label: 'Special requirements',
      type: 'textarea'
    },
    errorMessage: '',
    component: TextInput,
    data: 'notesValue',
    name: 'notes'
  }
];



// WEBPACK FOOTER //
// ./src/containers/QuotePage/YourSummaryPanel/yourSummaryOutboundData.js